import { render, staticRenderFns } from "./StatusMultiSelect.vue?vue&type=template&id=036de8ea"
import script from "./StatusMultiSelect.vue?vue&type=script&lang=js"
export * from "./StatusMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports